import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SubmissionGridViewModel } from '@program-suite/data-common';
import { TSubmissionGridViewModel } from '@program-suite/data-common/program';

@Injectable({
  providedIn: 'root',
})
export class SubmissionGridService {
  http = inject(HttpClient);

  /**
   * get submission grid
   * @returns 200 - OK(SubmissionGridViewModel)
   * @throws Error if fails
   */
  async getSubmissionGrid(params: any): Promise<SubmissionGridViewModel | TSubmissionGridViewModel> {
    try {
      return await firstValueFrom(this.http.get('Submission/submissions', {params, responseType: 'json' }));
    } catch (error) {
      throw new Error('Something went wrong, please try again');
    }
  }
}
